(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["sticker-visualizer"] && !Shopify.designMode) return;
  try {
    (() => {
    const roots = document.querySelectorAll('[data-sticker-visualizer]');

    roots.forEach((root) => {
      if (root.dataset.initialized === 'true') return;
      root.dataset.initialized = 'true';

      const canvas = root.querySelector('[data-sticker-canvas]');
      const context = canvas.getContext('2d', { willReadFrequently: true });
      const fileName = root.querySelector('[data-sticker-file-name]');
      const message = root.querySelector('[data-sticker-message]');
      const approval = root.querySelector('[data-sticker-approval]');
      const borderControls = root.querySelector('[data-sticker-border-controls]');
      const fillControls = root.querySelector('[data-sticker-fill-controls]');
      const backgroundButtons = root.querySelectorAll('[data-sticker-background]');
      let selectedBackground = '#ffffff';
      let selectedBorder = 'normal';
      let selectedStickerBackground = 'white';
      let currentImage = null;
      let currentFile = null;
      let currentObjectUrl = null;
      let isOpaque = false;

      const findProductForm = () => root.closest('form[action*="/cart/add"]') || document.querySelector('form[action*="/cart/add"]');

      const syncApprovalProperty = () => {
        const form = findProductForm();
        if (!form) return;
        let property = form.querySelector('input[data-sticker-approval-property]');
        if (!property) {
          property = document.createElement('input');
          property.type = 'hidden';
          property.name = 'properties[Artwork preview approval]';
          property.dataset.stickerApprovalProperty = 'true';
          form.appendChild(property);
        }
        property.value = approval.checked ? `Approved - ${selectedBorder} border` : 'Not approved';

        let backgroundProperty = form.querySelector('input[data-sticker-background-property]');
        if (!backgroundProperty) {
          backgroundProperty = document.createElement('input');
          backgroundProperty.type = 'hidden';
          backgroundProperty.name = 'properties[Sticker background]';
          backgroundProperty.dataset.stickerBackgroundProperty = 'true';
          form.appendChild(backgroundProperty);
        }
        backgroundProperty.value = selectedStickerBackground === 'black'
          ? root.dataset.stickerBackgroundBlack
          : root.dataset.stickerBackgroundWhite;
      };

      const createMask = (imageData) => {
        const mask = document.createElement('canvas');
        mask.width = canvas.width;
        mask.height = canvas.height;
        const maskContext = mask.getContext('2d');
        const output = maskContext.createImageData(mask.width, mask.height);
        let transparentPixels = 0;

        for (let index = 0; index < imageData.data.length; index += 4) {
          const alpha = imageData.data[index + 3];
          if (alpha < 250) transparentPixels += 1;
          if (alpha > 12) {
            output.data[index] = 255;
            output.data[index + 1] = 255;
            output.data[index + 2] = 255;
            output.data[index + 3] = 255;
          }
        }

        maskContext.putImageData(output, 0, 0);
        isOpaque = transparentPixels < 10;
        return mask;
      };

      const dilateMask = (mask, radius, color) => {
        const result = document.createElement('canvas');
        result.width = canvas.width;
        result.height = canvas.height;
        const resultContext = result.getContext('2d');
        const step = radius > 18 ? 3 : 2;

        for (let x = -radius; x <= radius; x += step) {
          for (let y = -radius; y <= radius; y += step) {
            if ((x * x) + (y * y) <= radius * radius) {
              resultContext.drawImage(mask, x, y);
            }
          }
        }

        resultContext.globalCompositeOperation = 'source-in';
        resultContext.fillStyle = color;
        resultContext.fillRect(0, 0, result.width, result.height);
        resultContext.globalCompositeOperation = 'source-over';
        return result;
      };

      const borderRadius = () => {
        if (selectedBorder === 'thin') return 10;
        if (selectedBorder === 'wide') return 30;
        return 20;
      };

      const render = () => {
        context.clearRect(0, 0, canvas.width, canvas.height);
        context.fillStyle = selectedBackground;
        context.fillRect(0, 0, canvas.width, canvas.height);
        if (!currentImage) return;

        const padding = 80;
        const scale = Math.min(
          (canvas.width - (padding * 2)) / currentImage.naturalWidth,
          (canvas.height - (padding * 2)) / currentImage.naturalHeight
        );
        const width = currentImage.naturalWidth * scale;
        const height = currentImage.naturalHeight * scale;
        const x = (canvas.width - width) / 2;
        const y = (canvas.height - height) / 2;
        const artwork = document.createElement('canvas');
        artwork.width = canvas.width;
        artwork.height = canvas.height;
        const artworkContext = artwork.getContext('2d', { willReadFrequently: true });
        artworkContext.drawImage(currentImage, x, y, width, height);
        const imageData = artworkContext.getImageData(0, 0, artwork.width, artwork.height);
        const mask = createMask(imageData);
        const radius = borderRadius();
        const cutline = dilateMask(mask, radius + 4, '#26a9e0');
        const border = dilateMask(mask, radius, '#ffffff');
        const backingRadius = Math.max(radius - 8, 2);
        const backingColor = selectedStickerBackground === 'black' ? '#000000' : '#ffffff';
        const backing = dilateMask(mask, backingRadius, backingColor);

        context.drawImage(cutline, 0, 0);
        context.drawImage(border, 0, 0);
        context.drawImage(backing, 0, 0);
        context.drawImage(artwork, 0, 0);

        const productSection = root.closest('[data-section-id]') || document;
        const currentProductImage = productSection.querySelector('.product-single__photo-wrapper img');
        if (currentProductImage) {
          const imageFrame = currentProductImage.closest('.product-single__photo');
          const proofImage = currentProductImage.cloneNode(false);
          proofImage.src = canvas.toDataURL('image/png');
          proofImage.removeAttribute('srcset');
          proofImage.removeAttribute('data-src');
          proofImage.removeAttribute('data-srcset');
          proofImage.removeAttribute('data-widths');
          proofImage.removeAttribute('data-sizes');
          proofImage.removeAttribute('data-aspectratio');
          proofImage.classList.remove('lazyload', 'lazypreload', 'js-zoom-enabled');
          proofImage.classList.add('lazyloaded');
          proofImage.alt = fileName.textContent;
          proofImage.style.position = 'absolute';
          proofImage.style.inset = '0';
          proofImage.style.width = '100%';
          proofImage.style.height = '100%';
          proofImage.style.objectFit = 'contain';
          proofImage.style.objectPosition = 'center';
          if (imageFrame) {
            const proofFrame = imageFrame.cloneNode(false);
            proofFrame.style.paddingTop = '100%';
            proofFrame.style.cursor = 'default';
            proofFrame.style.pointerEvents = 'none';
            proofFrame.classList.remove('js-zoom-enabled');
            proofFrame.removeAttribute('data-zoom');
            proofFrame.appendChild(proofImage);
            imageFrame.replaceWith(proofFrame);
          } else {
            currentProductImage.replaceWith(proofImage);
          }
        }

        message.textContent = isOpaque ? root.dataset.opaqueMessage : root.dataset.transparentMessage;
        message.classList.toggle('is-warning', isOpaque);
      };

      const showManualReview = (file) => {
        root.hidden = false;
        fileName.textContent = file.name;
        currentImage = null;
        currentFile = file;
        approval.checked = false;
        borderControls.hidden = true;
        fillControls.hidden = true;
        context.clearRect(0, 0, canvas.width, canvas.height);
        context.fillStyle = selectedBackground;
        context.fillRect(0, 0, canvas.width, canvas.height);
        message.textContent = root.dataset.manualMessage;
        message.classList.add('is-warning');
        syncApprovalProperty();
      };

      const loadFile = (file) => {
        currentFile = file;
        root.hidden = false;
        fileName.textContent = file.name;
        approval.checked = false;
        syncApprovalProperty();

        const isPreviewable = file.type.startsWith('image/') || /\.(png|jpe?g|webp|gif|svg)$/i.test(file.name);
        if (!isPreviewable) {
          showManualReview(file);
          return;
        }

        borderControls.hidden = false;
        fillControls.hidden = false;
        if (currentObjectUrl) URL.revokeObjectURL(currentObjectUrl);
        currentObjectUrl = URL.createObjectURL(file);
        const image = new Image();
        image.onload = () => {
          currentImage = image;
          render();
        };
        image.onerror = () => {
          currentImage = null;
          message.textContent = root.dataset.errorMessage;
          message.classList.add('is-warning');
        };
        image.src = currentObjectUrl;
      };

      document.addEventListener('change', (event) => {
        const input = event.target;
        if (!(input instanceof HTMLInputElement) || input.type !== 'file' || !input.files || !input.files.length) return;
        const form = input.closest('form[action*="/cart/add"]');
        if (form && findProductForm() && form !== findProductForm()) return;
        loadFile(input.files[0]);
      }, true);

      root.addEventListener('change', (event) => {
        const input = event.target;
        if (!(input instanceof HTMLInputElement)) return;
        if (input.name === 'sticker-preview-border') {
          selectedBorder = input.value;
          approval.checked = false;
          syncApprovalProperty();
          render();
        }
        if (input.name === 'sticker-production-background') {
          selectedStickerBackground = input.value;
          approval.checked = false;
          syncApprovalProperty();
          render();
        }
        if (input.matches('[data-sticker-approval]')) syncApprovalProperty();
      });

      backgroundButtons.forEach((button) => {
        button.addEventListener('click', () => {
          selectedBackground = button.dataset.stickerBackground;
          backgroundButtons.forEach((item) => item.classList.toggle('is-selected', item === button));
          render();
        });
      });

      const requireApproval = (event) => {
        if (!currentFile || approval.checked) {
          approval.setCustomValidity('');
          return true;
        }

        event.preventDefault();
        event.stopImmediatePropagation();
        approval.focus();
        approval.setCustomValidity(root.dataset.errorMessage);
        approval.reportValidity();
        return false;
      };

      const form = findProductForm();
      if (form) {
        form.addEventListener('submit', requireApproval, true);
        form.addEventListener('click', (event) => {
          if (!(event.target instanceof Element)) return;
          const button = event.target.closest('button[type="submit"], input[type="submit"], [name="add"]');
          if (!button || !form.contains(button)) return;
          requireApproval(event);
        }, true);
      }
    });
  })();
  } catch(e) { console.error(e); }
})();

})();
